
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "mb-switch",
  props: {
    label: { type: String, default: "", required: true },
    shortKey: { type: String, default: "" },
    modelValue: { type: String, default: "0" },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const switchVal = ref(props.modelValue);

    watch(
      () => props.modelValue,
      (newVal) => {
        switchVal.value = newVal;
      }
    );

    const handleChange = (val) => {
      switchVal.value = val;
      context.emit("update:modelValue", val);
    };

    return {
      switchVal,
      handleChange,
    };
  },
});
